import { render, staticRenderFns } from "./SuricataAlertsSummary.vue?vue&type=template&id=1422f193&scoped=true&"
import script from "./SuricataAlertsSummary.vue?vue&type=script&lang=js&"
export * from "./SuricataAlertsSummary.vue?vue&type=script&lang=js&"
import style0 from "./SuricataAlertsSummary.vue?vue&type=style&index=0&id=1422f193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1422f193",
  null
  
)

export default component.exports